import { Box } from "@mui/material";
import { useImpactRating } from "./use-impact-rating";
import { ImpactRatingUnit } from "./impact-rating-unit";
import { ImpactData, ImpactRatingOptions } from "./types";

type ImpactCirclesProps = {
  impactData: ImpactData;
  color: string;
  options?: ImpactRatingOptions;
  centerDots?: boolean;
};

export const ImpactRating = ({
  impactData,
  color,
  options,
  centerDots = false,
}: ImpactCirclesProps) => {
  const { paintedImpactRating, gap } = useImpactRating({
    impactData,
    color,
    options,
  });

  return (
    <Box
      display="flex"
      gap={`${gap}px`}
      justifyContent={centerDots ? "center" : "unset"}
    >
      {paintedImpactRating.map((paintedImpactRatingUnit, index) => (
        <ImpactRatingUnit
          key={index}
          backgroundColor={paintedImpactRatingUnit.backgroundColor}
          borderColor={paintedImpactRatingUnit.borderColor}
          options={options}
        />
      ))}
    </Box>
  );
};
